import FilterAltIcon from '@mui/icons-material/FilterAlt';
import classNames from 'classnames';
import React, { useEffect, useState } from 'react';
import {
  columns,
  fetchAllocationTable,
} from '../../helpers/Allocation/AllocationTable';
import c from '../Allocation/allocation.module.scss';
import CustomSelect from '../Layout/Select';
import CustomTable from '../Shared/Table';
import Text from '../Shared/Text';
import AllocationTable from './AllocationTable';
import { useSelector } from 'react-redux';
import { TextField } from '@mui/material';
import { useDebouncedCallback } from 'use-debounce';
import { CLIENT_ID } from '../../config/Constants';
import { googleAnalyticsTriggerFn } from '../../utils/utility';

const Allocation = () => {
  const [data, setData] = useState({});
  const [search, setSearch] = useState('');
  const [tablePageNo, setTablePageNo] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  const client_id = useSelector(
    (state) => state?.generalInformation?.client_id
  );

  const debounced = useDebouncedCallback(
    // function
    () => {
      getAllocationTableData();
    },
    // delay in ms
    400
  );

  useEffect(() => {
    if (client_id) {
      getAllocationTableData();
    }
    // eslint-disable-next-line
  }, [client_id, tablePageNo, rowsPerPage]);

  const getAllocationTableData = async () => {
    const params = {
      corporate_id: client_id,
      platform_id: CLIENT_ID, //Ahura Client ID
      limit: rowsPerPage,
      search: search,
      page_no: tablePageNo + 1,
    };
    const response = await fetchAllocationTable(params);
    if (response) {
      setData(response?.data);
    }
  };

  const handleSearch = (value) => {
    setSearch(value);
    debounced();
    googleAnalyticsTriggerFn('Search', 'Search', 'Searched on allocation page');
  };

  return (
    <>
      <div className={classNames('bg-white rounded', c.allocation)}>
        <div className="row g-0 p-4 align-items-center">
          <div className="col-9">
            <Text
              textType="t0"
              classToOverride={classNames(c.fontWeight500, c.heading)}
            >
              Members
            </Text>
          </div>
          <div className="col-3 p-3">
            <TextField
              className={classNames('w-100')}
              name="search"
              label="Search"
              type="text"
              id="search"
              size="small"
              onChange={(e) => handleSearch(e.target.value)}
            />
          </div>

          {/* <div className="col-3">
            <CustomSelect label="Filter" dropdownIcon={FilterAltIcon} />
          </div> */}
        </div>
        <div className={classNames('row g-0', c.tableContainer)}>
          <CustomTable
            pageNo={tablePageNo}
            setTablePageNo={setTablePageNo}
            rowsPerPage={rowsPerPage}
            setRowsPerPage={setRowsPerPage}
            columns={columns}
            minWidth={true}
            showSortIcon={false}
            // count={50}
          >
            {/* {[...Array(10)].map(() => {
              return <AllocationTable />;
            })} */}
            {data &&
              data.length > 0 &&
              data.map((item, index) => {
                return (
                  <React.Fragment key={index}>
                    <AllocationTable
                      name={item?.full_name}
                      // department={item?.user_info?.department}
                      studyHours={item?.duration}
                      sessions={item?.sessions}
                      topics={item?.topics}
                      // viewDashboard={}
                      assign={item?.license_active_status}
                      isAdmin={item?.is_admin}
                      isTeacher={item?.user_info?.is_teacher}
                      saveVideo={item?.recording_flag}
                      ext_id={item?.user_info?.external_id}
                      user_id={item?.user_id}
                      user_client_id={item?.user_info?.user_client_id}
                      getAllocationTableData={getAllocationTableData}
                    />
                  </React.Fragment> //Why is it needed
                );
              })}
          </CustomTable>
        </div>
      </div>
    </>
  );
};
export default Allocation;
